import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import {
  getDocuments,
  setDocument,
  setPolicy,
  getPoliciesDetails,
  setAddedToWallet,
  clearDocument,
  clearPolicy,
} from '../actions'
import {
  documents,
  addedToWallet,
  loading,
  loaded,
  timeAdded,
  policiesDetails,
  hasSlipConsent,
} from '../reselect'

import AllSlips from './AllSlips'

const mapDispatchToProps = {
  getDocuments,
  setDocument,
  setPolicy,
  getPoliciesDetails,
  setAddedToWallet,
  clearDocument,
  clearPolicy,
}

const mapStateToProps = state => {
  return {
    loaded: loaded(state),
    loading: loading(state),
    documents: documents(state),
    addedToWallet: addedToWallet(state),
    timeAdded: timeAdded(state),
    policiesDetails: policiesDetails(state),
    featureFlags: getFromSettings(state, 'featureFlags', []),
    user: state.user.user,
    isWidgetState: state.appReducer.isWidget,
    labels: getFromSettings(state, 'labels', {}),
    countryIsoCode: getFromSettings(state, 'countryIsoCode'),
    hasSlipConsent: hasSlipConsent(state),
    features: state.appReducer.features,
    language: state.appReducer.language,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllSlips)
